export const getSelectedCompanies = (userCompanies, selectedCompanies) => {
  let companyArray = [];

  if (!selectedCompanies) {
    return [];
  } else if (!Array.isArray(selectedCompanies)) {
    companyArray = [selectedCompanies];
  } else {
    companyArray = [...selectedCompanies];
  }

  return userCompanies.filter(o =>
    companyArray.find(o2 => {
      if (o2.value) {
        return o._id === o2.value;
      } else {
        return o._id === o2;
      }
    })
  );
};

export const getSelectedGroups = (selectedCompanies, selectedGroups) => {
  let groupArray = [];
  if (!Array.isArray(selectedGroups)) {
    groupArray = [selectedGroups];
  } else {
    groupArray = [...selectedGroups];
  }

  groupArray = groupArray.map(group => {
    if (group && group.value) {
      return group.value;
    }

    return group;
  });

  const groups = [];

  if (selectedCompanies.length > 0) {
    selectedCompanies.forEach(company =>
      company.groups.forEach(group => {
        if (groupArray.indexOf(group._id) > -1) {
          groups.push(group);
        }
      })
    );
  }
  return groups;
};

export const getSelectedProjects = (selectedGroups, selectedProjects) => {
  if (!selectedProjects) {
    return null;
  }

  const projects = [];

  if (selectedGroups.length > 0) {
    selectedGroups.forEach(group =>
      group.projects.forEach(project => {
        if (selectedProjects.indexOf(project._id) > -1) {
          projects.push(project);
        }
      })
    );
  }

  return projects;
};

export const getUsersByEstablishmentCollabLevel = (
  userList,
  establishmentId
) => {
  return userList
    .filter(
      user =>
        user.groupIds.indexOf(establishmentId) > -1 &&
        // eslint-disable-next-line
        (user.userAccount.accessLevel == 500 ||
          // eslint-disable-next-line
          user.userAccount.accessLevel == 900)
    )
    .map(user => {
      return {
        value: user.userAccount._id,
        label: `${user.person.firstName} ${user.person.lastName}`
      };
    });
};

export const getUsersByEstablishmentSuperLevel = (
  userList,
  establishmentId
) => {
  return userList
    .filter(
      user =>
        user.groupIds.indexOf(establishmentId) > -1 &&
        // eslint-disable-next-line
        user.userAccount.accessLevel != 100
    )
    .map(user => {
      return {
        value: user.userAccount._id,
        label: `${user.person.firstName} ${user.person.lastName}`
      };
    });
};
